import { createContext } from 'react';
import { QUERY_KEYS_SAS, useChartsData } from '../../../../Common/hooks/useChartsData';
import { useIgdFiltersContext } from '../../../Common/Filters/hooks/useIgdFiltersContext';
import { useAnnualSynthesis } from '../../../Common/hooks/useAnnualSynthesis';
export const IDCREASChartsDataContext = createContext();

const normalizeSize = (value) => {
    if (!value) {
        return 'Não informado';
    }

    const sizeMap = {
        '1': 'Pequeno I',
        '2': 'Pequeno II',
        '3': 'Médio',
        '4': 'Grande',
    };

    return sizeMap[value] || value;
};

const IDCREASChartsDataProvider = ({ children }) => {
    const { filters } = useIgdFiltersContext();

    const requestFilters = {
        year: filters?.year?.value ?? '',
        location: filters.unidade.value,
        city: filters.cidade?.value,
    };

    const generalQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCREAS_GENERAL,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idcreas/general',
        },
        requestFilters
    );

    const sizeQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCREAS_SIZE,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idcreas/size',
        },
        requestFilters
    );

    const structureQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCREAS_STRUCTURE,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idcreas/structure',
        },
        requestFilters
    );

    const humanResourcesQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCREAS_HUMAN_RESOURCES,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idcreas/humanResources',
        },
        requestFilters
    );

    const servicesQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCREAS_SERVICES,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idcreas/services',
        },
        requestFilters
    );

    // O backend repete o mesmo ano (uma linha por unidade); sintetiza em um ponto por ano.
    const general = useAnnualSynthesis(generalQuery.data?.anualEvolution, [
        'idcreas'
    ]);
    const structure = useAnnualSynthesis(structureQuery.data?.anualEvolution, [
        'estrutura_fisica'
    ]);
    const humanResources = useAnnualSynthesis(
        humanResourcesQuery.data?.anualEvolution,
        ['recursos_humanos']
    );
    const services = useAnnualSynthesis(servicesQuery.data?.anualEvolution, [
        'servicos'
    ]);

    const chartData = {
        general,

        size:
            sizeQuery.data?.anualEvolution?.map((item) => ({
                ...item,
                porte: normalizeSize(item.porte),
            })) ?? [],

        structure,

        humanResources,

        services,
    };

    const isLoading =
        generalQuery.isLoading ||
        sizeQuery.isLoading ||
        structureQuery.isLoading ||
        humanResourcesQuery.isLoading ||
        servicesQuery.isLoading;

    const isError =
        generalQuery.isError ||
        sizeQuery.isError ||
        structureQuery.isError ||
        humanResourcesQuery.isError ||
        servicesQuery.isError;

    return (
        <IDCREASChartsDataContext.Provider
            value={{
                chartData,
                filters,
                isLoading,
                isError,

                rawData: {
                    general: generalQuery.data,
                    size: sizeQuery.data,
                    structure: structureQuery.data,
                    humanResources: humanResourcesQuery.data,
                    services: servicesQuery.data,
                },
            }}
        >
            {children}
        </IDCREASChartsDataContext.Provider>
    );
};

export default IDCREASChartsDataProvider;